import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  /* ── List Page ─────────────────────────────────── */
  pageContainer: {
    width: '100%',
    maxWidth: '800px',
    margin: '0 auto',
    padding: '24px 16px 40px',
  },
  pageTitle: {
    fontWeight: 700,
    fontSize: '22px',
    marginBottom: '20px',
  },
  addSection: {
    background: '#2C325C',
    borderRadius: '12px',
    padding: '20px 24px',
    marginBottom: '16px',
  },
  addForm: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    flexWrap: 'wrap' as any,
  },
  ctaButton: {
    background: '#ffee58',
    color: '#1E2141',
    fontWeight: 700,
    fontSize: '13px',
    padding: '10px 24px',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    transition: 'background 0.2s, transform 0.15s',
    whiteSpace: 'nowrap' as any,
    '&:hover': {
      background: '#fdd835',
      transform: 'translateY(-1px)',
    },
    '&:active': {
      transform: 'translateY(0)',
    },
    '&:disabled': {
      opacity: 0.6,
      cursor: 'not-allowed',
    },
  },
  usageBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '2px',
    background: '#23284B',
    borderRadius: '6px',
    padding: '5px 10px',
    cursor: 'help',
    whiteSpace: 'nowrap' as any,
    fontSize: '13px',
    fontWeight: 600,
    color: '#ffffffaa',
  },
  usageCount: {
    color: '#ffee58',
    fontWeight: 700,
    fontSize: '14px',
  },
  usageSeparator: {
    color: '#ffffff44',
    fontSize: '12px',
    margin: '0 1px',
  },
  usageTotal: {
    color: '#ffffff66',
    fontSize: '13px',
    fontWeight: 600,
  },
  loadingBox: {
    background: '#2C325C',
    borderRadius: '12px',
    padding: '48px 24px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '16px',
  },
  loadingText: {
    marginTop: '16px',
    fontSize: '13px',
    color: '#ffffff99',
    animation: '$pulse 1.5s ease-in-out infinite',
  },
  '@keyframes pulse': {
    '0%, 100%': { opacity: 0.5 },
    '50%': { opacity: 1 },
  },
  emptyBox: {
    background: '#2C325C',
    borderRadius: '12px',
    padding: '40px 24px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '16px',
  },
  emptyState: {
    textAlign: 'center',
    color: '#ffffff55',
    fontSize: '13px',
    maxWidth: '360px',
    lineHeight: 1.6,
  },
  historyBox: {
    background: '#2C325C',
    borderRadius: '12px',
    overflow: 'hidden',
  },
  historyBody: {
    padding: '6px',
  },
  historyCard: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 14px',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'background 0.15s',
    '&:hover': {
      background: '#ffffff0a',
    },
  },
  historyCardLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  historyCardIcon: {
    width: '32px',
    height: '32px',
    borderRadius: '8px',
    background: '#23284B',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  historyCardInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  historyCardDate: {
    fontWeight: 600,
    fontSize: '14px',
    color: '#ffffffdd',
  },
  historyCardStats: {
    fontSize: '12px',
    color: '#ffffffaa',
  },
  historyCardPnl: {
    fontWeight: 700,
    fontSize: '15px',
    whiteSpace: 'nowrap' as any,
  },
  historyDivider: {
    height: '1px',
    background: '#ffffff08',
    margin: '0 14px',
  },

  /* ── Detail Page ───────────────────────────────── */
  container: {
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '8px 4px 40px',
  },
  detailHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    margin: '4px 4px 8px',
    padding: '4px 0',
  },
  detailHeaderCenter: {
    flex: 1,
    textAlign: 'center',
  },
  detailTitle: {
    fontSize: '22px',
    fontWeight: 700,
    color: '#ffffffdd',
  },
  detailDate: {
    fontSize: '13px',
    color: '#ffffffaa',
    marginTop: '2px',
  },

  /* ── Summary Layout (Score | 4 stats | Resultado) */
  summaryLayout: {
    display: 'grid',
    gridTemplateColumns: '1.3fr 3fr 1.3fr',
    gap: '8px',
    margin: '4px 4px 8px',
    alignItems: 'stretch',
    '@media (max-width: 700px)': {
      gridTemplateColumns: '1fr',
    },
  },
  scoreItem: {
    background: '#2C325C',
    borderRadius: '10px',
    padding: '16px 20px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  scoreCircle: {
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    border: '3px solid',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '8px',
  },
  scoreNumber: {
    fontSize: '22px',
    fontWeight: 800,
  },
  scoreLabel: {
    fontSize: '10px',
    color: '#ffffff55',
    fontWeight: 600,
    textTransform: 'uppercase' as any,
    letterSpacing: '0.8px',
  },
  scoreExplanation: {
    fontSize: '11px',
    color: '#ffffff77',
    marginTop: '8px',
    lineHeight: 1.4,
    maxWidth: '100%',
  },
  statsCenter: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '1fr 1fr',
    gap: '8px',
  },
  summaryItem: {
    background: '#2C325C',
    borderRadius: '10px',
    padding: '8px 12px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  resultadoItem: {
    background: '#2C325C',
    borderRadius: '10px',
    padding: '16px 24px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  resultadoValue: {
    fontSize: '24px',
    fontWeight: 800,
  },
  summaryLabel: {
    fontSize: '10px',
    color: '#ffffff55',
    fontWeight: 600,
    textTransform: 'uppercase' as any,
    letterSpacing: '0.8px',
    marginBottom: '6px',
  },
  summaryValue: {
    fontSize: '18px',
    fontWeight: 700,
    color: '#fff',
  },
  periodBadge: {
    textAlign: 'center',
    margin: '0 4px 4px',
    padding: '6px 0',
    fontSize: '12px',
    color: '#ffffff55',
  },

  /* ── Insight Cards Grid ───────────────────────── */
  cardsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    '@media (max-width: 800px)': {
      gridTemplateColumns: '1fr',
    },
  },
  insightCardFull: {
    background: '#2C325C',
    borderRadius: '10px',
    overflow: 'hidden',
    margin: '4px',
  },
  insightCard: {
    background: '#2C325C',
    borderRadius: '10px',
    overflow: 'hidden',
    margin: '4px',
    display: 'flex',
    flexDirection: 'column',
  },
  insightCardHeader: {
    background: '#23284B',
    height: '30px',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '14px',
    gap: '8px',
  },
  insightCardTitle: {
    fontWeight: 600,
    fontSize: '13px',
    color: '#ffffffdd',
  },
  insightCardBody: {
    padding: '14px 16px',
    flex: 1,
  },
  insightCardText: {
    fontSize: '13px',
    color: '#ffffffbb',
    lineHeight: 1.8,
  },

  /* ── Action Plan ────────────────────────────────── */
  actionPlanCard: {
    background: '#2C325C',
    borderRadius: '10px',
    overflow: 'hidden',
    margin: '4px',
    marginTop: '8px',
  },
  actionPlanBody: {
    padding: '16px 18px',
  },
  actionPlanItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    padding: '8px 0',
    '& + &': {
      borderTop: '1px solid #ffffff08',
    },
  },
  actionPlanBullet: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    background: '#4BDC4B',
    flexShrink: 0,
    marginTop: '5px',
  },
  actionPlanText: {
    fontSize: '13px',
    color: '#ffffffcc',
    lineHeight: 1.6,
  },
});
